module.exports = __webpack_public_path__ + "img/fig22.4e5f66a0.jpg";